import React from 'react'

const ShipperDocs = ({ shipment }) => {

    if (shipment.shipperDocuments && shipment.shipperDocuments.length) {
        return (
            <div className="row mb-3 mt-3">
                <div className="col">
                    <span className="bold">Shipping Documents:</span><br />
                    {shipment.shipperDocuments.map((document, index) => <a href={document.url} target="_blank" rel="noopener noreferrer " key={index}><span className='text-capitalize'>{document.name}</span></a>)}
                </div>
            </div>
        )
    } else { return null }
}

export default ShipperDocs
